import * as actions from "../actions/marketsActions";
import produce from "immer";
import isEqual from "lodash.isequal";

const initialState = {
  dict: {}
};

export default function markets(state = initialState, action) {
  switch (action.type) {
    case actions.SET_MARKETS: {
      return produce(state, draft => {
        Object.values(action.markets).forEach(market => {
          const marketId = market.id;
          const oldMarket = state.dict[marketId];

          if (!oldMarket || !isEqual(oldMarket, market)) {
            draft.dict[marketId] = market;
          }
        }, {});

        Object.keys(state.dict).forEach(marketId => {
          if (!action.markets[marketId]) {
            delete draft.dict[marketId];
          }
        })
      });
    }
    default: {
      return state;
    }
  }
}


// WEBPACK FOOTER //
// ./app/reducers/markets.js